import { render } from "./PropertyValue.vue?vue&type=template&id=291de1ba&ts=true"
import script from "./PropertyValue.vue?vue&type=script&lang=ts"
export * from "./PropertyValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__